import { DataTableId } from '../../../common/table/utils';
import { SalesforceItem } from '../../../parser/ParserTypes';
import {
  DataTableBaseColumn,
  DataTableRow,
  DataTableOnSortChangeClbk,
} from '../../../common/table/TableTypes';
import { SubPageTypes } from '../../types';
import { DropdownProps } from '@sweep-io/sweep-design/dist/components/Tabs/tabsTypes';
import { SortOrder } from '../../../common/types';

export interface BaseLayoutProps {
  isExpandedMode: boolean;
  crmOrgId: string;
  columns: DataTableBaseColumn[];
  rows: DataTableRow[];
  pageType: SubPageTypes;
  topBarProps: LayoutTopBarProps;
  tableProps?: LayoutTableProps;
  tabsProps?: LayoutTabsProps;
  header?: React.ReactNode;
  dataTestId?: string;
}

export interface LayoutTopBarProps {
  searchPlaceholder?: string;
  sortOptions?: { label: string; value: string }[];
  sortProps?: { sortBy: string; sortOrder: SortOrder };
  downloadCsvJsx?: React.ReactNode;
  filtersJsx?: React.ReactNode;
  label: string;
  pageHeader?: string;
  hideFiltersAndSort?: boolean;
  showResultsCount?: boolean;
}

export interface LayoutTableProps {
  tableId: DataTableId;
  onRowClick: (
    event: React.MouseEvent<HTMLTableCellElement, MouseEvent>,
    row: DataTableRow,
  ) => void;
  onSortChange: DataTableOnSortChangeClbk;
  allowColumnsManipulation?: boolean;
  tableType?: LayoutTableType;
  transformRows?: (rows: DataTableRow[]) => DataTableRow[];
}

export interface LayoutDependenciesPanelProps {
  configurationItem: SalesforceItem;
  type: string;
}

export interface LayoutTabsProps {
  tabs: { label: string; value: string }[];
  dropdown?: DropdownProps;
  activeTab: string;
  onTabChange: (event: React.SyntheticEvent, newValue: string) => void;
}

export enum LayoutTableType {
  table = 'table',
  virtualizedTable = 'virtualizedTable',
  virtualizedTableWithCustomColumns = 'virtualizedTableWithCustomColumns',
  customColumnsTable = 'customColumnsTable',
}
